import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import type { KYCFlowState } from '../KYCFlowController';

interface CompletionScreenProps {
  state: KYCFlowState;
  // Llamado cuando el usuario confirma que leyó el resultado y cierra el widget
  onDismiss?: () => void;
  // D-7: disponible solo cuando state.canReset === true (ALLOW_KYC_RESET=true en backend).
  // La UI que lo expone se implementa en Step 6; aquí se recibe como prop para permitir el tipado.
  onReset?: () => void;
}

// Pantalla final de éxito: KYC aprobado completamente
export function CompletionScreen({ state, onDismiss }: CompletionScreenProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        gap: 2,
        textAlign: 'center',
      }}
    >
      <CheckCircleIcon sx={{ fontSize: 80, color: 'success.main' }} />

      <Typography variant="h4" fontWeight={700}>
        ¡Verificación completada!
      </Typography>

      <Typography variant="body1" color="text.secondary">
        Tu identidad ha sido verificada exitosamente. Puedes proceder con tu retiro.
      </Typography>

      {/* Badges de score si están disponibles */}
      {(state.idScore || state.poaScore) && (
        <Stack direction="row" spacing={1} sx={{ mt: 2 }} justifyContent="center" flexWrap="wrap">
          {state.idScore && (
            <Chip
              label={`Identificación: ${state.idScore.score}/100`}
              color="success"
              size="small"
              variant="outlined"
            />
          )}
          {state.poaScore && (
            <Chip
              label={`Comprobante: ${state.poaScore.score}/100`}
              color="success"
              size="small"
              variant="outlined"
            />
          )}
          {state.livenessScore !== null && (
            <Chip
              label={`Prueba de vida: ${state.livenessScore}/100`}
              color="success"
              size="small"
              variant="outlined"
            />
          )}
        </Stack>
      )}

      {/* El usuario debe confirmar explícitamente para cerrar el widget */}
      {onDismiss && (
        <Button
          variant="contained"
          color="success"
          onClick={onDismiss}
          sx={{ mt: 3 }}
        >
          Entendido
        </Button>
      )}
    </Box>
  );
}
